import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

export function AdminRoute() {
  const { user } = useAuthStore()

  if (!user?.is_staff) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}